import Console from './Console';

export default Console;
